const postalCodeSpecific = ['br', 'ie', 'us', 'in']

const administrativeAreaSpecific = [
  'hk',
  'ie',
  'tw',
  'co',
  'ni',
  'nr',
  'kr',
  'ae',
  'ru',
  'ua',
  'bb',
  'jm',
  'jp',
  'br',
  'es',
  'bs',
  'cv',
  'ky',
  'pf',
  'kn',
  'sc',
  'tv',
]

const localitySpecific = ['th', 'hk', 'tr', 'no', 'se', 'gb', 'au']

const sublocalitySpecific = [
  'kr',
  'ng',
  'br',
  'mx',
  'nz',
  'ph',
  'za',
  'th',
  'ie',
  'my',
]

export function getLocalizedAddressVersion(key, regionCode = '') {
  const parsedRegionCode = regionCode.toLowerCase().split('-')[0]

  switch (key) {
    case 'postalCode':
      const pcSpecific = postalCodeSpecific.includes(parsedRegionCode)
        ? `postalCode.${parsedRegionCode}`
        : 'postalCode.generic'
      return pcSpecific
    case 'administrativeArea':
      const aaSpecific = administrativeAreaSpecific.includes(parsedRegionCode)
        ? `administrativeArea.${parsedRegionCode}`
        : 'administrativeArea.generic'
      return aaSpecific
    case 'locality':
      const lSpecific = localitySpecific.includes(parsedRegionCode)
        ? `locality.${parsedRegionCode}`
        : 'locality.generic'
      return lSpecific
    case 'sublocality':
      const slSpecific = sublocalitySpecific.includes(parsedRegionCode)
        ? `sublocality.${parsedRegionCode}`
        : 'sublocality.generic'
      return slSpecific
    default:
      return 'generic'
  }
}
